import { render } from "./Terminal.vue?vue&type=template&id=86c10c92&ts=true"
import script from "./Terminal.vue?vue&type=script&lang=ts"
export * from "./Terminal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__